import React, { useEffect, useRef, useState } from 'react';
import { aiStudioPalette, colors } from '@guryou/colors';
import { MoreIcon } from '../icons';

// Action buttons for the L2 right zone. A single action renders inline as its own button
// (e.g. "Add Plan"); as soon as a page has more than `max` (default 1), ALL of them
// collapse behind one "⋮" overflow menu button — the zone must never grow past the width
// of one button. Inline styles only (shared lib — consuming app's Tailwind does not scan it).
const OverflowActions = ({
  children,
  max = 1
}) => {
  const items = React.Children.toArray(children).filter(Boolean);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onDoc = e => ref.current && !ref.current.contains(e.target) && setOpen(false);
    const onEsc = e => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onEsc);
    };
  }, [open]);
  if (items.length === 0) {
    return null;
  }
  if (items.length <= max) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
      }
    }, items);
  }
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: () => setOpen(o => !o),
    "aria-label": "More actions",
    "aria-expanded": open,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 36,
      height: 36,
      borderRadius: 8,
      border: `1px solid ${aiStudioPalette.border}`,
      background: colors.white,
      color: aiStudioPalette.muted2,
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(MoreIcon, {
    style: {
      fontSize: 20
    }
  })), open && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      right: 0,
      top: 'calc(100% + 8px)',
      zIndex: 1000,
      minWidth: 220,
      borderRadius: 12,
      border: `1px solid ${aiStudioPalette.border}`,
      background: colors.white,
      padding: 8,
      boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
      display: 'flex',
      flexDirection: 'column',
      gap: 4
    }
  }, items.map((item, i) => /*#__PURE__*/React.createElement("div", {
    key: i,
    onClick: () => setOpen(false)
  }, item))));
};
export default OverflowActions;